import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import { getAccessToken } from "../../utils/auth";

const PublicRoute = ({ children }) => {
  const accessToken = getAccessToken();
  return accessToken ? <Navigate to="/" /> : children;
};

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PublicRoute;
